import React, { Component } from "react";
import DOMPurify from "dompurify";
import { connect } from "react-redux";
import { getProductsByCategory } from "../../store/actions/product";
import { setCategory, getCategoryBySlug } from "../../store/actions/category";
import PageTitle from "../../components/shared/PageTitle";
import CategoriesWidget from "../../components/shared/CategoriesWidget";
import CartWidget from "../../components/shared/CartWidget";
import SEO from "../../components/shared/SEO";

import Loading from "../../components/shared/Loading";
import { generatePageTitle, generateMetaDescription, generateKeywords, generateBreadcrumbs, generateCanonicalUrl } from "../../helpers/seo";

class Page extends Component {
  state = { page: null };
  componentDidMount() {
    this.setState(
      {
        page: this.props.page.page.find(
          ({ slug }) => slug === this.props.match.params.slug
        )
      },
      () => {
        window.scrollTo(0, 0);
      }
    );
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.match.params.slug !== prevProps.match.params.slug) {
      this.setState(
        {
          page: this.props.page.page.find(
            ({ slug }) => slug === this.props.match.params.slug
          )
        },
        () => {
          window.scrollTo(0, 0);
        }
      );
    }
  }

  render() {
    const { setting } = this.props;
    const currentPage = this.state.page;
    
    // SEO data for page
    const pagePageSEO = currentPage ? {
      title: generatePageTitle('page', currentPage, setting && setting.setting && setting.setting.title),
      description: generateMetaDescription('page', currentPage, setting && setting.setting && setting.setting.title),
      keywords: generateKeywords('page', currentPage, ['bilgi', 'hakkında', 'hizmet']),
      type: 'article',
      url: `/p/${currentPage.slug}`,
      canonical: generateCanonicalUrl('page', currentPage),
      breadcrumbs: generateBreadcrumbs('page', currentPage),
      article: {
        title: currentPage.content_title || currentPage.menu_title,
        content: currentPage.content,
        meta_description: currentPage.meta_description,
        created_at: currentPage.created_at,
        updated_at: currentPage.updated_at
      }
    } : null;

    return (
      <React.Fragment>
        {pagePageSEO && <SEO {...pagePageSEO} />}
        <PageTitle title={this.state.page && this.state.page.menu_title} />
        <div className="row">
          <div className={"container"}>
            <div className="row">
              <div className={"col-md-9"}>
                <div
                  className={"row"}
                  style={{ marginTop: 20, marginBottom: 50 }}
                >
                  <h3 style={{ width: "100%" }}>
                    {this.state.page && this.state.page.content_title}
                  </h3>
                  <div
                    style={{ width: "100%" }}
                    dangerouslySetInnerHTML={{
                      __html: this.state.page && DOMPurify.sanitize(this.state.page.content)
                    }}
                  />
                </div>
              </div>
              <div className={"col-md-3"}>
                <CartWidget />
                <CategoriesWidget />
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ page, setting }) => {
  return { page, setting };
};

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Page);



// WEBPACK FOOTER //
// ./src/routers/Page/index.js